import styled, { keyframes } from 'styled-components'
import { COLOR } from 'src/constants/colors'

interface SpinnerPorps {
  $top?: string
  $height?: string
  $width?: string
  $left?: string
}

const Spinner = (props: SpinnerPorps) => {
  return <SpinnerWrap {...props} />
}
export default Spinner

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`
const SpinnerWrap = styled.section<SpinnerPorps>`
  position: relative;
  width: ${(props) => props.$width ?? '100%'};
  height: ${(props) => props.$height ?? '100%'};
  &:after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    left: ${(props) => props.$left ?? '47%'};
    top: ${(props) => props.$top ?? '35%'};
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 3px solid lightgrey;
    border-top-color: ${COLOR.brand};
    border-right-color: ${COLOR.brand};
    animation: ${spinAnimation} 0.8s linear infinite;
  }
`
